import type { RouteRecordRaw } from 'vue-router'

export const coachesRoutes: RouteRecordRaw[] = [
  {
    path: '/coaches',
    name: 'coaches',
    component: () => import('./views/CoachesView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
  {
    path: '/locations',
    name: 'locations',
    component: () => import('./views/LocationsView.vue'),
    meta: { requiresAuth: true, roles: ['owner', 'admin'] },
  },
]
